
import Cell from 'vux/src/components/cell/index.vue'

import { queryOrder, orderPay } from "@/model/trader/queryServer";
import { store } from "@/observable/store";
import { paySystem,payIsWeixin } from "@/utils/pay/parameter.js";
import  mixinPay  from "@/utils/mixin/mixinPay.js";
import Txrweb from '@/utils/mixin/mixinTxrweb'
import bridgeApi from "sy-bridge";

export default {
name: "stencilPay",
mixins: [mixinPay,Txrweb],
data() {
return {

list:[]
}
},
computed: {
templateFlag() {
return this.$route.query.templateFlag;
},
outTrade() {
return this.$route.query.outTrade;
},
typeflag() {
return this.templateFlag == "coupon" ? "coupon" : "insurance";
},
wxCode() {
return store.wxCode;
},
uuid() {
let uuid = this.$route.query.uuid;

if (Array.isArray(uuid)) {
uuid = uuid[0];
}
return uuid
},
},
components: {
Cell,
},
created () {

queryOrder({ type: this.typeflag, outTrade: this.outTrade }).then((data) => {
this.list = [
{ name:'商品信息:',value:data.goods[0].name },
{ name:'订单编号:',value:data.out_trade_no },
{ name:'支付金额:',value:'¥'+ (data.goods[0].amount / 100) },
]
if (data.repeat) { //重复投保
this.$toast(data.message);
}

});
},
mounted () {
this.STATISTICS_CONFIG.insur_cashier_page();
this.payTX()
},
methods: {
infoClick() {
this.$router.push({
path: "/quota",
});
},
orderPrice() {
this.STATISTICS_CONFIG.insur_cashier_pay_click();

this.$loading.show()
let parmer = {
outTrade: this.outTrade,
data: {
pay_type: "3", //1 支付宝 3微信
code: this.wxCode,
system: paySystem(), //1是app
is_weixin: payIsWeixin(),
url: `/stencilSuccess?uuid=${this.uuid}&outTrade=${this.outTrade}&flag=postdisable&templateFlag=${this.templateFlag}`, //目前没有使用
app_id:bridgeApi.appInfo? bridgeApi.appInfo.app_id : '', // appid
}
}
orderPay(parmer).then((data) => {
this.$loading.hide()
if(data.entrust_info){//签约
this.paySign(data)
}else{ //支付
this.topayTX(data,"3")
}
}).catch((err) => {

this.$toast(err.message);



}).finally(()=>{
this.$loading.hide()
});
},
},
}
